// extracted by mini-css-extract-plugin
export var collapse = "ambassadors-roles-module--collapse--773a3";
export var even = "ambassadors-roles-module--even--be48f";
export var image = "ambassadors-roles-module--image--d0796";
export var odd = "ambassadors-roles-module--odd--e3ab6";
export var role = "ambassadors-roles-module--role--1afb9";
export var roles = "ambassadors-roles-module--roles--25b86";
export var section = "ambassadors-roles-module--section--fcc8b";
export var text = "ambassadors-roles-module--text--45e4d";